var _excluded = ["input", "meta", "children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import CheckboxGroup from '../../CheckboxGroup';

var CheckboxGroupAdapter = function CheckboxGroupAdapter(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(CheckboxGroup, rest, children);
};

CheckboxGroupAdapter.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  children: PropTypes.node
};
CheckboxGroupAdapter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckboxGroupAdapter",
  "props": {
    "input": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "meta": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
export default CheckboxGroupAdapter;